import { FiMoreHorizontal } from "react-icons/fi";
import type { ButtonHTMLAttributes } from "react";

type KebabButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function KebabButton({
  className = "",
  type = "button",
  ...props
}: KebabButtonProps) {
  return (
    <button
      aria-label="Open menu"
      className={`inline-flex h-7 w-7 items-center justify-center rounded text-ink-subtle transition-colors hover:bg-gray-100 hover:text-ink ${className}`}
      type={type}
      {...props}
    >
      <FiMoreHorizontal aria-hidden="true" />
    </button>
  );
}
